module.exports = __webpack_public_path__ + "img/demoTask.860c84d9.png";